export default __webpack_public_path__ + "static/media/bg-gradient-proprietari.f03c2da1.png";